import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/tag/importer/tagImporterActions';

export default importerReducers(actions);
